// 二维码
<template>
  <div class="qrCodeBox">
    <div class="qrcode">
      <YCL v-if="show" :labelInfo="labelInfo" :modelInfo="modelInfo" />
      <!-- <YCL :labelInfo="labelInfo" v-if="labelType == 'YCL'" />
      <MJ :labelInfo="labelInfo" v-if="labelType == 'MJ'" />
      <CP :labelInfo="labelInfo" v-if="labelType == 'CP'" /> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {
    YCL: () => import("./components/YCL.vue"),
    CP: () => import("./components/CP.vue"),
    MJ: () => import("./components/MJ.vue"),
  },
  props: {
    labelType: {
      type: Number,
      default: 1,
    },
    currentLabel: {
      type: Object,
      default: {},
    },
    labelNo: {
      type: String,
      default: "",
    },
    modelInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      labelInfo: {},
      show: false,
    };
  },
  mounted() {
    console.log("modelInfo", this.modelInfo);
    console.log("this.currentLabel", this.currentLabel);
    // if(this.currentLabel && this.currentLabel.label_no_new) {
    //   this.getnewLabelInfo(this.currentLabel.label_no_new);
    // } else {
    //   this.getLabelInfo();
    // }
    this.getLabelInfo();
  },
  methods: {
    getnewLabelInfo(labelNo) {
      let _this = this;
      console.log("labelNo", labelNo);
      let params = { labelNo: labelNo };
      let httpCall = this.doUrl(
        "/admin/online/onlineLabel/labelInfo",
        "get",
        params
      );
      httpCall
        .then((res) => {
          console.log("res.data", res.data);
          let { data } = res;
          this.labelInfo = {
            id: this.labelNo,
            ...data,
          };
          this.show = true;
        })
        .catch((e) => {});
    },
    getLabelInfo() {
      let _this = this;
      console.log("labelNo", this.labelNo);
      let params = { labelNo: this.labelNo };
      let httpCall = this.doUrl(
        "/admin/online/onlineLabel/labelInfo",
        "get",
        params
      );
      httpCall
        .then((res) => {
          console.log("res.data", res.data);
          let { data } = res;
          this.labelInfo = {
            id: this.labelNo,
            ...data,
          };
          this.show = true;
        })
        .catch((e) => {});
    },

    onIn(i) {
      console.log("onIn 1111111");
      this.$parent.onIn(i);
    },
  },
};
</script>
